import React from "react";
import { Link } from "react-router-dom";
import { Instagram, Mail, Heart } from "lucide-react";
import { openCookiePreferences } from "../lib/analytics";

export default function Footer() {
  return (
    <footer className="bg-[#141311] text-white/80">
      <div className="max-w-6xl mx-auto px-6 py-12 md:py-16">
        <div className="flex flex-col md:flex-row md:items-start md:justify-between gap-8">
          <div>
            <div className="flex items-center gap-4">
              <img
                src="https://customer-assets.emergentagent.com/job_pet-portraits-4/artifacts/txcaddf3_logo%20def1.png"
                alt="Retrato Mascotas"
                className="h-20 w-auto"
              />
              <img
                src="https://customer-assets.emergentagent.com/job_pet-portraits-4/artifacts/sh7tvxjx_logo%20def2.png"
                alt="Retrato Mascotas"
                className="h-9 w-auto"
                style={{ filter: "brightness(0) invert(1)" }}
              />
            </div>
            <p className="mt-3 text-sm text-white/60">Retratos únicos en madera blanca</p>
            <p className="mt-2 text-xs text-white/50">
              Artex Galería Digital · C/ Francisco Pizarro, 14 · 06001 Badajoz
            </p>
          </div>

          <nav
            className="flex flex-wrap gap-x-6 gap-y-2 text-sm text-white/70"
            data-testid="footer-legal-nav"
          >
            <Link
              to="/aviso-legal"
              className="hover:text-[#d4b97a] transition-colors"
              data-testid="footer-link-aviso-legal"
            >
              Aviso legal
            </Link>
            <Link
              to="/privacidad"
              className="hover:text-[#d4b97a] transition-colors"
              data-testid="footer-link-privacidad"
            >
              Privacidad
            </Link>
            <Link
              to="/terminos"
              className="hover:text-[#d4b97a] transition-colors"
              data-testid="footer-link-terminos"
            >
              Términos
            </Link>
            <Link
              to="/cookies"
              className="hover:text-[#d4b97a] transition-colors"
              data-testid="footer-link-cookies"
            >
              Cookies
            </Link>
            <button
              type="button"
              onClick={openCookiePreferences}
              className="hover:text-[#d4b97a] transition-colors"
              data-testid="footer-cookie-settings"
            >
              Configurar cookies
            </button>
          </nav>

          <div className="flex items-center gap-3">
            <a
              href="#"
              aria-label="Instagram"
              className="h-10 w-10 rounded-full border border-white/15 flex items-center justify-center hover:border-[#d4b97a] hover:text-[#d4b97a] transition-colors"
            >
              <Instagram className="h-4 w-4" />
            </a>
            <a
              href="mailto:artexsala@gmail.com"
              aria-label="Email"
              className="h-10 w-10 rounded-full border border-white/15 flex items-center justify-center hover:border-[#d4b97a] hover:text-[#d4b97a] transition-colors"
            >
              <Mail className="h-4 w-4" />
            </a>
          </div>
        </div>

        <div className="mt-10 pt-6 border-t border-white/10 text-center text-sm text-white/60 inline-flex w-full items-center justify-center gap-2">
          Hecho con <Heart className="h-3.5 w-3.5 text-[#d4b97a]" fill="#d4b97a" /> para los amantes de mascotas
        </div>
      </div>
    </footer>
  );
}
